<template>
  <div>
    <canvas id="bmi-chart" height="500" width="400"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'


export default {
  name: "ChartBmi",
  props: ['chartLabel', 'studentBmiData', 'underWeightData', 'overWeightData', 'obeseData', 'normalWeightData'],
  data: function () {
    return {
      planetChartData: {
        type: 'line',
        data: {
          labels: this.chartLabel,
          datasets: [
              {
            label: 'BMI',
            backgroundColor: '#8057EF',
            borderColor: '#8057EF',
            showLine: true,
            fill: false,
            data: this.studentBmiData,
          }, {
            label: 'کمبود وزن',
            backgroundColor: 'rgba(46,70,178,0.3)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#2e46b2',
            fill: true,
            data: this.underWeightData,

          }, {
            label: 'طبیعی',
            backgroundColor: 'rgba(86,189,36,0.30)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#56bd24',
            fill: +1,
            data: this.normalWeightData,

          }, {
            label: 'اضافه وزن',
            backgroundColor: 'rgba(246,196,5,0.30)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#f6c405',
            fill: +1,
            data: this.overWeightData,

          }, {
            label: 'چاقی',
            backgroundColor: 'rgba(236,56,46,0.30)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#ec382e',
            fill: +1,
            data: this.obeseData,

          }]
        },
        options: {
          responsive: true,
          legend: {
            display: true,
            position: 'top',
            rtl: true,
            labels: {
              color: 'rgb(255, 99, 132)'
            }
          },
          scales: {
            xAxes: [{
              display: true,
            }],
            yAxes: [{
              display: true,
              ticks: {
                min: 0,
                stepSize: 2
              }
            }]
          }

        },
      }
    }
  },
  mounted() {
    Chart.defaults.global.defaultFontFamily = "IRANSans";
    const ctx = document.getElementById('bmi-chart');
    new Chart(ctx, this.planetChartData);
  }

}
</script>

<style scoped>

</style>